define('app/views/shipping_address_form_view',['app/setup','app/models/shipping_address'], function(takhfifan,shippingAddress) {

  takhfifan.ShippingAddressFormView = Backbone.View.extend({

    template: ( $('#tkh-shipping-address-form').length > 0 ) ?
      _.template( $('#tkh-shipping-address-form').html() ) : '',

    events: {
      'click .tkh-save-shipping': 'save',
      'click .tkh-regions li': 'regionClicked',
      'focus .tkh-regions .default-text': 'toggleRegions',
      'blur .tkh-regions .default-text': 'toggleRegions',
      'keydown .tkh-regions ': 'exploreRegions'
    },

    exploreRegions: function(e){
      var $activeLi = $(this.$('.tkh-regions li.active').length? this.$('.tkh-regions li.active')[0] : this.$('.tkh-regions li')[0]),
          topOfActiveItem  = $activeLi.position().top,
          topOfUL = $activeLi.parent('ul').position().top;

      switch(e.keyCode) {
        case 38: //up
          e.preventDefault();
          $activeLi.removeClass('active');
          $activeLi.prev('li').addClass('active');
          $activeLi.parents('.dropdown-items').scrollTop(Math.abs(topOfUL) - Math.abs(topOfActiveItem));
          break;
        case 40: //down
          e.preventDefault();
          $activeLi.removeClass('active');
          $activeLi.next('li').addClass('active');
          $activeLi.parents('.dropdown-items').scrollTop(topOfActiveItem + Math.abs(topOfUL));
          break;
        case 13: //enter
          var regionId = $activeLi.data('regionId'),
              regionName = $activeLi.text();
          this.setRegion(regionName, regionId);
          break;
      }
    },

    initialize: function() {
      var _this = this;

      takhfifan.eventHub.on('formkey', function(formKey) {
        _this.model.set('formKey', formKey);
      }, this);

      /*takhfifan.eventHub.on('shipping:error', function(errors) {
        _this.renderErrors(errors);
      }, this);*/

      takhfifan.eventHub.on('shipping:updated', function(errors) {
        this.enableSubmitBtn();
        _this.$el.slideUp();
      }, this);

      Backbone.Validation.bind(this);

      this.render();
    },

    render: function() {
      var _this = this;
      this.$el.html( this.template( {data: this.model.toJSON()} ) ).slideDown(function(){
        _this.$submitBtn = _this.$('.tkh-save-shipping');
        _this.$submitBtnTxt = _this.$submitBtn.text();
        $('html, body').animate({
          scrollTop: _this.$el.offset().top - 55
        }, 500);
      });
    },

    renderErrors: function(errors) {
      this.$('.success').empty().hide();
      var $errors = this.$('.alert-error');
      $errors.empty();
      _.each(errors, function(e) {
        var $li = $('<li></li>');
        $li.html(e);
        $errors.append($li);
      });
      $errors.show();
    },

    save: function(e) {
      e.preventDefault();
      this.updateModel();
      this.validate();
      if (this.model.isValid()) {
        this.model.save();
        this.disableSubmitBtn();
      } else {
        e.preventDefault();
        this.$('.alert-error').slideDown();
      }
    },

    updateModel: function() {
      var data = takhfifan.Helper.serializeToObject(this);
      this.model.set(data);
      this.validate();
    },

    loadFormData: function(data) {
      if (_.isNull(data)) {
        this.model.clearFormData(data);
      } else {
        this.model.loadFormData(data);
      }

      this.render();
    },

    validate: function() {
      if (_.isUndefined(this.model.validate)) {
        Backbone.Validation.bind(this);
      }
      if (this.model.validate() && !this.model.isValid()) {
        this.$('.alert-error').show();
      }
    },

    toggleVisibility: function() {
      this.$el.slideToggle();
    },

    toggleRegions: function(e) {
      if(e && $(e.relatedTarget).hasClass('dropdown-items')){return}
      if(e && e.type ==="focusin") {
        this.$('.tkh-regions .dropdown-items').show();
      } else {
        this.$('.tkh-regions .dropdown-items').hide();
      }
    },

    setRegion: function(regionName, regionId){
      this.$(".tkh-regions span.value").text(regionName);
      this.$("#region_id").val(regionId);
      this.model.set({
        'regionName': regionName,
        'region': regionName,
        'region_id': regionId
      }, { validate: false });
      this.$("#region_id").parent('.control-wrapper').next('.control-wrapper').find('input').focus();
      this.toggleRegions();
    },

    regionClicked: function(e) {
      var $target = $(e.target);
      var regionId = $target.data('regionId');
      var regionName = $target.text();
      this.$('.tkh-regions li').removeClass('active');
      $target.addClass('active');
      this.setRegion(regionName, regionId);
    },

    disableSubmitBtn: function () {
      this.$submitBtn.prop('disabled',true).empty().append('<div class="btn-text"><span class="spinner"></span></div>');
    },

    enableSubmitBtn: function () {
      this.$submitBtn.prop('disabled',false).empty().append(this.submitBtnText);
    }

  });

});

